import styled from 'styled-components';

const StyledCheckbox = styled.input``;

export default StyledCheckbox;
